import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const url = config.url || "";
  if (url.includes("/admin/")) {
    const t = localStorage.getItem("admin_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
  } else {
    const t = localStorage.getItem("user_token") || localStorage.getItem("access_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    const isAuthCall = url.includes("/login") || url.includes("/register") || url.includes("/access/verify");
    if (status === 401 && !isAuthCall) {
      if (url.includes("/admin/")) {
        localStorage.removeItem("admin_token");
        if (window.location.pathname.startsWith("/admin")) window.location.href = "/admin";
      } else if (url.includes("/user/") || url.includes("/registrations")) {
        localStorage.removeItem("user_token");
      } else {
        localStorage.removeItem("access_token");
        if (window.location.pathname !== "/") window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export function formatEur(x) {
  return `${Number(x || 0).toFixed(2)} €`.replace(".", ",");
}

export function activityFromPrice(a) {
  const cand = [];
  (a?.age_brackets || []).forEach((b) => {
    [b.amount, ...Object.values(b.group_prices || {}), ...Object.values(b.associate_prices || {})].forEach((v) => {
      const n = Number(v);
      if (v != null && v !== "" && Number.isFinite(n) && n > 0) cand.push(n);
    });
  });
  (a?.tariffs || []).forEach((t) => { const n = Number(t.amount); if (Number.isFinite(n) && n > 0) cand.push(n); });
  return cand.length ? Math.min(...cand) : null;
}
